import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Integrations from "../../integration/Integrations.jsx";

class ConnectIntegrationButton extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            integrationKey: this.props.integrationKey || '',
            url: this.props.url || '',
            className: this.props.className || 'btn-light border',
            style: this.props.style || {},
            disabled: this.props.disabled === true,
            logoWidth: this.props.logoWidth || '75',
            logoHeight: this.props.logoHeight || '',
            signUp: this.props.signUp || false,
            iconBtnColor: this.props.iconBtnColor || 'btn-light',
            actionBtnColor: this.props.actionBtnColor || 'btn-light',
            label: this.props.label || '',
            buttonLabel: this.props.buttonLabel || null,
            onClickOverride: this.props.onClickOverride || null,
        }
    }

    componentWillReceiveProps(nextProps) {
        let state = {
            className: nextProps.className || '',
            style: nextProps.style || {},
            logoWidth: nextProps.logoWidth || '75',
            disabled: nextProps.disabled === true,
            url: nextProps.url || '',
            label: nextProps.label || '',
        }
        this.setState(state)
    }

    onClick() {
        if (this.state.onClickOverride) {
            this.state.onClickOverride()
        } else {
            location.href = this.state.url +
                `?referrer=${this.props.referrer}` +
                `&utmMedium=${this.props.utmMedium}` +
                `&utmCampaign=${this.props.utmCampaign}` +
                `&utmSource=${this.props.utmSource}`
        }
    }

    render() {
        if (this.state.label) {
            return <a href={this.state.url} className={'btn ' + this.state.className}
                style={this.state.style} disabled={this.state.disabled}>
                {this.state.label}
            </a>
        }

        return this.state.signUp ?
            <div className="btn-group" role="group" aria-label="sign-up-lightspeed" style={{width:"65%"}}>
                <button type="button" className={'btn border ' + this.state.iconBtnColor} style={{ 'pointerEvents': 'none'}}>
                    {Integrations.getIntegrationIcon(this.state.integrationKey, '20')}
                </button>
                <button type="button" className={'btn border ' + this.state.actionBtnColor} style={{width:"80%"}} onClick={() => this.onClick()}>
                    {
                        this.state.buttonLabel ?
                            this.state.buttonLabel :
                            <FormattedMessage
                                id="common.integration.sign_up_btn"
                                defaultMessage="Sign up with {integrationName}"
                                values={{
                                    integrationName: Integrations.getIntegrationNameFromKey(this.state.integrationKey)
                                }}
                            />
                    }

                </button>
            </div> :
            <button 
                type="button" 
                className={'btn btn-light border ' + this.state.className}
                style={this.state.style} 
                disabled={this.props.disabled}
                onClick={() => {
                    location.href = this.state.url
                }}
            >
                <FormattedMessage
                    id="common.integration.connect_btn"
                    defaultMessage="Connect with {integrationKey}"
                    values={{
                        integrationKey: Integrations.getIntegrationLogoImage(this.state.integrationKey, this.state.logoWidth, this.state.logoHeight)
                    }}
                />
            </button>
    }
}

export default ConnectIntegrationButton


// WEBPACK FOOTER //
// ./src/common/button/connectintegrationbutton.component.jsx